import {
  eDmLoaiLopTinChiActionsObj,
  IDmLoaiLopTinChiActionTypes,
} from "../../action-types/category/IDmLoaiLopTinChiActions";
import { IDmLoaiLopTinChiReducer } from "../../reducer-model/category/IDmLoaiLopTinChiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDmLoaiLopTinChiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  loaiLopTinChis: [],
};

export const dmLoaiLopTinChiReducer = (
  state: IDmLoaiLopTinChiReducer = iniState,
  action: IDmLoaiLopTinChiActionTypes
): IDmLoaiLopTinChiReducer => {
  switch (action.type) {
    case "DM_LOAI_LOP_TIN_CHI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "DM_LOAI_LOP_TIN_CHI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiLopTinChis: action.payload,
      };
    case "DM_LOAI_LOP_TIN_CHI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DM_LOAI_LOP_TIN_CHI_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        loaiLopTinChiEditing: action.payload,
      };
    case "DM_LOAI_LOP_TIN_CHI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "DM_LOAI_LOP_TIN_CHI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DM_LOAI_LOP_TIN_CHI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DM_LOAI_LOP_TIN_CHI_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DM_LOAI_LOP_TIN_CHI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DM_LOAI_LOP_TIN_CHI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DM_LOAI_LOP_TIN_CHI_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};

